module.exports = __webpack_public_path__ + "img/img8.45da869c.png";